export type TiktokService = {
  identify: (payload: Record<string, unknown>) => void;
  track: (action: string, payload?: Record<string, unknown>) => void;
};

export default function makeTiktokService(): TiktokService {
  function identify(payload: Record<string, unknown>): void {
    if (global.ttq?.identify) {
      global.ttq.identify(payload);
    }
  }

  function track(action: string, payload?: Record<string, unknown>): void {
    if (global.ttq?.track) {
      global.ttq.track(action, payload);
    }
  }

  return {
    identify,
    track,
  };
}
